import Immutable from 'seamless-immutable';
import createReducer from '../helpers/createReducer';
import {
  config as state
} from '../store';

export default createReducer(state, {
  SET_LANGS: (state, { data }) => Immutable({ ...state, langs: data }),
  SET_LANG: (state, { data }) => Immutable({ ...state, lang: data }),
  SET_TRANSLATIONS: (state, { data }) => Immutable({ ...state, translations: data }),
  SET_PKG_VERSION: (state, { data }) => Immutable({ ...state, pkgVersion: data }),
  SET_PACKAGE_TYPE: (state, { data }) => Immutable({ ...state, packageType: data })
});
